'use client';

import { canInitiatePasswordReset } from '@/utils/supabase/password-auth';
import { useBrowserAuthUser } from '@/utils/supabase/use-browser-auth-user';
import { usePathname } from 'next/navigation';
import HeaderAuthClient from './header-auth-client';

export default function HeaderAuth() {
  const pathname = usePathname();
  const isTranslateRoute = pathname?.includes('/translate') ?? false;
  const { user, isLoading } = useBrowserAuthUser();

  const friendlyName = user?.is_anonymous
    ? null
    : typeof user?.user_metadata?.friendly_name === 'string'
      ? user.user_metadata.friendly_name
      : null;

  const canManagePassword = !!user && !user.is_anonymous && canInitiatePasswordReset(user);

  const handleHistoryClick = () => {
    // Dispatch custom event that the translate page can listen to
    window.dispatchEvent(new CustomEvent('open-translation-history'));
  };

  return (
    <HeaderAuthClient
      user={user ? { email: user.email, is_anonymous: user.is_anonymous } : null}
      friendlyName={friendlyName}
      canManagePassword={canManagePassword}
      isLoading={isLoading}
      onHistoryClick={isTranslateRoute ? handleHistoryClick : undefined}
    />
  );
}
